import { useTranslation } from 'react-i18next';
import { View, Text } from 'react-native';
import { Pagination } from '../../client/interfaces';
import { PropsWithClassName } from '../../resources/interfaces';
import { cln } from '../../utils/classnames';

export interface Props extends PropsWithClassName {
  pagination?: Pagination;
  totalCount?: number;
}

const ResultCounter: React.FC<Props> = ({ pagination, totalCount, classNames }) => {
  const { t } = useTranslation('common');

  return (
    <View className={cln('min-w-[12rem] min-h-[4rem]', classNames)}>
      {!!pagination?.total && !!pagination?.toNumber && !!pagination?.fromNumber && (
        <View className="flex flex-row flex-nowrap">
          <Text className="text-subHeader text-neutral-950 dark:text-neutral-50 font-[sans-700]">
            {pagination?.fromNumber + '-'}
            {pagination?.toNumber + ' / '}
            {pagination?.total + ' '}
          </Text>
          <Text className="text-subHeader text-neutral-950 dark:text-neutral-50 font-[sans-400]">
            {t('common:total_result')}
          </Text>
        </View>
      )}
      {totalCount !== undefined && !pagination && (
        <View className="flex flex-row flex-nowrap">
          <Text className="text-subHeader text-neutral-950 dark:text-neutral-50 font-[sans-700]">
            {totalCount + ' '}
          </Text>
          <Text className="text-subHeader text-neutral-950 dark:text-neutral-50 font-[sans-400]">
            {totalCount <= 1 ? t('common:total_result') : t('common:total_results')}
          </Text>
        </View>
      )}
    </View>
  );
};

export default ResultCounter;
